import * as Types from './workstationActionTypes.js'

const initialState = {
    workstations: [],
    machineParameters: [],
    activeWorkstations: [],
    workstationStatusses: [],
    selectedWorkstation: 0,
    restrictions: [],
    workingHours: [],
    restrictionTypes: [],
    workstationNotificationsDrawerOpen: false
};

export default function workstation(state = initialState, action) {
    switch (action.type) {
        case Types.SET_WORKSTATIONS:
            if (state.workstations !== action.workstations) {
                return Object.assign({}, state, { workstations: action.workstations });
            }
            return state;
        case Types.SET_MACHINEPARAMETERS:
            if (state.machineParameters !== action.parameters) {
                return Object.assign({}, state, { machineParameters: action.parameters });
            }
            return state;
        case Types.SET_WORKSTATIONSTATUSSES:
            if (state.workstationStatusses !== action.workstationStatusses) {
                return Object.assign({}, state, { workstationStatusses: action.workstationStatusses });
            }
            return state;
        case Types.SET_ACTIVEWORKSTATIONS:
            if (state.activeWorkstations !== action.activeWorkstations) {
                return Object.assign({}, state, { activeWorkstations: action.activeWorkstations });
            }
            return state;
        case Types.SET_SELECTEDWORKSTATION:
            if (state.selectedWorkstation !== action.selectedWorkstation) {
                return Object.assign({}, state, { selectedWorkstation: action.selectedWorkstation });
            }
            return state;
        case Types.SET_RESTRICTIONS:
            if (state.restrictions !== action.restrictions) {
                return Object.assign({}, state, { restrictions: action.restrictions });
            }
            return state;
        case Types.SET_WORKINGHOURS:
            if (state.workingHours !== action.workingHours) {
                return Object.assign({}, state, { workingHours: action.workingHours });
            }
            return state;
        case Types.SET_RESTRICTIONTYPES:
            if (state.restrictionTypes !== action.restrictionTypes) {
                return Object.assign({}, state, { restrictionTypes: action.restrictionTypes });
            }
            return state;
        case Types.SET_WORKSTATIONNOTIFICATIONSDRAWEROPEN:
            if (state.workstationNotificationsDrawerOpen !== action.workstationNotificationsDrawerOpen) {
                return Object.assign({}, state, { workstationNotificationsDrawerOpen: action.workstationNotificationsDrawerOpen });
            }
            return state;
        default:
            return state;
    }
}